export default async (context:any, payload:any) => {
    const vtl = payload.oneLni.environment.current.apiLocation2.indexOf('vtl');
    const baseEnv = payload.oneLni.environment.current.apiLocation2.substring(0, vtl);
    const url = `${baseEnv}content/id/${payload.id}`;

    const data = await fetch(url)
        .then(response => response.json())
        .then(json => json)
        .catch(error => {
            console.warn(error);
        });

    return data.contentlets[0].json;
};